<template>
<div>
        <div class="large-scatter">
            <ChartScatter
                @dotClicked="dotClicked($event)"
                height="250" width="700"
                :chartData="points_filtered"
                :render_info="{
                  display_extra: false,
                  background_color_scale: 0
                }"
            />
        </div>
        <div class="medium-scatter">
            <ChartScatter
                @dotClicked="dotClicked($event)"
                height="250" width="400"
                :chartData="points_filtered"
                :render_info="{
                  display_extra: false,
                  background_color_scale: 0
                }"
            />
        </div>
</div>
</template>

<script>
export default {
    name: "CAFieldsScatter",
    props: ['fields','field_type_slug','approach_slug'],
    data() {
        return {
            pop_1: false,
            pop_2: false,
            pop_3: true,
            show_basic: true,
        }
    },
    computed: {
        fields_filtered: function () {
            if (this.fields) {
                return this.fields.filter(field => {
                    return true;
                    // we may come back to the logic below if we need dynamic filtering, but
                    // for now we're rolling with showing it all all the time
                    /*
                    if (!this.show_basic && field.field_type_pretty.slug==='basic') return false;
                    let tentative = false;
                    if (this.pop_1 && field.popularity === 1) tentative = true;
                    if (this.pop_2 && field.popularity === 2) tentative = true;
                    if (this.pop_3 && field.popularity === 3) tentative = true;
                    if (tentative && this.field_type_slug) {
                        if (field.field_type_pretty.slug === this.field_type_slug) return true;
                        else return false;
                    }
                    return tentative;
                     */
                })
            }


        },

        points_filtered: function () {

            let points = []
            this.fields_filtered.forEach(field => {
                let point = {
                    'x': field.automation_ease + Math.random() * 0.25 - 0.125,
                    'y': field.analysis_value  + Math.random() * 0.1 - 0.05,
                    'x_actual': field.automation_ease,
                    'y_actual': field.analysis_value,
                    'label': field.title,
                    'slug': field.slug,
                    'overlaps': field.field_type_pretty.slug === 'basic' ? true : false,
                    'category': field.field_type_pretty.label,
                    'category_actual': field.field_type_pretty.label,
                    'color': field.field_type_pretty.color,
                    'text_color': field.field_type_pretty.text_color,
                    'style': field.field_type_pretty.slug === 'basic' ? 'hollow' : 'solid',
                };
                points.push(point)
            })
            return {
                'data': points,
                'meta': {
                    'min_x': 0.5,
                    'min_y': 0.5,
                    'max_x': 10.5,
                    'max_y': 10.5,
                    'label': 'Useful Field',
                    'color_by_field': '',
                    'x': 'Ease of Automation',
                    'y': 'Value in Content Analysis'
                }
            }
        },
    },
    mounted() {

        if (this.field_type_slug || this.approach_slug) {
            this.pop_1 = true
            this.pop_2 = true
            this.pop_3 = true
        }
        $('.popularity-selector').click((event) => {
            // The actions
            var popularity = $(event.target).data('mode')
            this['pop_'+popularity]=!this['pop_'+popularity]
        })
    },
    methods: {
        dotClicked(event) {
            window.location.href= "/db/fields/" + event.slug
        },
    },
}
</script>

<style scoped>

</style>